import { fetchWrapper } from "@/helpers/fetch-wrapper";

/**
 * Serwis obsługujący pobieranie danych do filtrów (np. lista lokalizacji, użytkowników)
 */
class FiltersService {
  
  /**
   * Pobiera listę lokalizacji z API.
   * - Wysyła GET na endpoint `/locations`.
   * - Odwraca kolejność lokalizacji (`reverse()`), najnowsze będą pierwsze.
   * @returns {Promise<Array>} Tablica lokalizacji
   */
  async getLocations() {
    const locations = await fetchWrapper.get(`${process.env.VUE_APP_API_URL}/locations`);
    return locations.reverse();
  }

  /**
   * Pobiera listę użytkowników z API.
   * - Wysyła GET na endpoint `/users` z limitem 1000 użytkowników.
   * @returns {Promise<Array>} Tablica użytkowników
   */
  getUsers() {
    return fetchWrapper.get(`${process.env.VUE_APP_API_URL}/users?page=1&limit=1000`);
  }
}

// Eksportujemy pojedynczy (singleton) obiekt serwisu
export default new FiltersService();
